<template>
    <or-layout>

        <a-row :gutter="[16, 16]" type="flex" justify="space-between">
            <a-col :span="4">
                <a-select v-model="subject" @blur="handleChangesubject" mode="multiple" placeholder="学科"
                    style="width: 240px;padding-bottom: 10px;" allow-clear>
                   
                    <a-select-option :value="1">数学</a-select-option>
                    <a-select-option :value="2">英语</a-select-option>
                    <a-select-option :value="3">语文</a-select-option>
                    <a-select-option :value="4">化学</a-select-option>
                    <a-select-option :value="5">物理</a-select-option>
                </a-select>
                <a-select :v-model="grade_id" :key="gradeky" mode="multiple" default-value="a8d63f687cf09ff50c4d4b7cc090568c" style="width: 120px" @blur="handleChangegrade">
                    <a-select-option value="27fe6228e93f1516f7d3fc087a74665f">九年级</a-select-option>
                    <a-select-option value="0c7b4f40e5037b66b1efa642868eb0f2">八年级</a-select-option>
                    <a-select-option value="11fa873ce312ab5693e689cc89d5b46a">七年级</a-select-option>
                    <a-select-option value="9a32bce9b4dce97eddd5c0f8861416fc">六年级</a-select-option>
                    <a-select-option value="e2c94a56cae9c7b4c142816c80dd97ed">五年级</a-select-option>
                    <a-select-option value="389255d8b2d214fd2a7166f113b32848">四年级</a-select-option>
                    <a-select-option value="a8d63f687cf09ff50c4d4b7cc090568c">三年级</a-select-option>
                    <a-select-option value="f0ba1a33ec3c05323e85a39bb351bf54">二年级</a-select-option>
                    <a-select-option value="87f78e5f02b16dffac47646fe57cef9e">一年级</a-select-option>
                    
                </a-select>
                <a-select :v-model="semester_id" default-value="0" style="width: 120px"  @blur="handleChangesemester">
                    <a-select-option value="0">
                        全部学期
                    </a-select-option>
                    <a-select-option v-for="semester in semesterlist" :key="semester.id">
                        {{ semester.name }}
                    </a-select-option>
                </a-select>
                <a-tree :show-line=true :show-icon=true :defaultExpandAll=true @check="selectchapterItem" checkable
                    :treeData=basicChapterList :replaceFields=replaceFields>
                    <a-icon slot="icon" type="carry-out" />
                </a-tree>
            </a-col>
            <a-col :span="20">
                <a-form layout="inline">
                    <a-form-item>
                        <a-form-item>
                            <a-select v-model="searchFrom.subject" placeholder="学科" mode="multiple" style="width: 120px;" allow-clear>
                                <a-select-option :value="1">数学</a-select-option>
                                <a-select-option :value="2">英语</a-select-option>
                                <a-select-option :value="3">语文</a-select-option>
                                <a-select-option :value="4">化学</a-select-option>
                                <a-select-option :value="5">物理</a-select-option>
                            </a-select>
                        </a-form-item>

                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.campus_id"  mode="multiple" placeholder="校区" style="width: 150px;" allow-clear>
                            <a-select-option v-for="item in campusList" :key="item.id" :value="item.id">{{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.grade_id" placeholder="年级" mode="multiple"   style="width: 120px" @blur="handleChangegrade">
                    <a-select-option value="27fe6228e93f1516f7d3fc087a74665f">九年级</a-select-option>
                    <a-select-option value="0c7b4f40e5037b66b1efa642868eb0f2">八年级</a-select-option>
                    <a-select-option value="11fa873ce312ab5693e689cc89d5b46a">七年级</a-select-option>
                    <a-select-option value="9a32bce9b4dce97eddd5c0f8861416fc">六年级</a-select-option>
                    <a-select-option value="e2c94a56cae9c7b4c142816c80dd97ed">五年级</a-select-option>
                    <a-select-option value="389255d8b2d214fd2a7166f113b32848">四年级</a-select-option>
                    <a-select-option value="a8d63f687cf09ff50c4d4b7cc090568c">三年级</a-select-option>
                    <a-select-option value="f0ba1a33ec3c05323e85a39bb351bf54">二年级</a-select-option>
                    <a-select-option value="87f78e5f02b16dffac47646fe57cef9e">一年级</a-select-option>
                    
                </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.interval" placeholder="间隔时间" allow-clear style="width: 120px;">
                            <a-select-option :key="0" :value="0">全部</a-select-option>
                            <a-select-option :key="4" :value="4">每周五</a-select-option>
                            <a-select-option :key="1" :value="1">每周六</a-select-option>
                            <a-select-option :key="2" :value="2">每周天</a-select-option>
                            <a-select-option :key="3" :value="3">每天</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.opening" placeholder="开班状态" allow-clear style="width: 120px;">
                            <a-select-option :key="0" :value="0">未开班</a-select-option>
                            <a-select-option :key="1" :value="1">已开班</a-select-option>
                            <a-select-option :key="2" :value="2">已结班</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.is_famission" placeholder="发送任务" style="width: 120px;" allow-clear>
                            <a-select-option :value="1">发送</a-select-option>
                            <a-select-option :value="0">不发送</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.status" placeholder="班级状态" allow-clear style="width: 120px;">
                            <a-select-option :key="0" :value="0">禁用</a-select-option>
                            <a-select-option :key="1" :value="1">可用</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select v-model="searchFrom.semester_name" placeholder="季度" allow-clear style="width: 80px;">
                            <a-select-option :key="-1" value="">全部</a-select-option>
                            <a-select-option :key="0" value="寒假">寒假</a-select-option>
                            <a-select-option :key="1" value="春季">春季</a-select-option>
                            <a-select-option :key="2" value="暑假">暑假</a-select-option>
                            <a-select-option :key="3" value="秋季">秋季</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.year_name" placeholder="年度" allow-clear style="width: 90px;">
                            <a-select-option :key="-1" value="">全部</a-select-option>
								 <a-select-option :key="6" value="2026">2026年</a-select-option>
							 <a-select-option :key="5" value="2025">2025年</a-select-option>
							 <a-select-option :key="4" value="2024">2024年</a-select-option>
                            <a-select-option :key="3" value="2023">2023年</a-select-option>
                            <a-select-option :key="2" value="2022">2022年</a-select-option>
                            <a-select-option :key="0" value="2021">2021年</a-select-option>
                            <a-select-option :key="1" value="2020">2020年</a-select-option>
                        </a-select>
                    </a-form-item>
                    <!-- <a-form-item>
                        <a-select v-model="searchFrom.user_type" placeholder="老师/班主任" allow-clear style="width: 120px;">
                            <a-select-option :key="0" :value="0">老师</a-select-option>
                            <a-select-option :key="1" :value="1">班主任</a-select-option>
                        </a-select>
                    </a-form-item> -->
                    <a-form-item>
                        <a-select v-model="searchFrom.type" mode="multiple" placeholder="班型" allow-clear style="width: 120px;">
                            <a-select-option :key="0" :value="0">培优</a-select-option>
                            <a-select-option :key="1" :value="1">提高</a-select-option>
                            <a-select-option :key="2" :value="2">英才</a-select-option>
                            <a-select-option :key="3" :value="3">1对1VIP班</a-select-option>
                            <a-select-option :key="4" :value="4">体验课</a-select-option>
							 <a-select-option :key="5" :value="5">冲刺班</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-input placeholder="班级名称" v-model="searchFrom.keyword" @keyup.enter="tableSearch"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-input placeholder="班主任" v-model="searchFrom.instructor" @keyup.enter="tableSearch"></a-input>
                    </a-form-item>
                    <a-form-item>
                        <a-input placeholder="老师" v-model="searchFrom.teachaername" @keyup.enter="tableSearch"></a-input>
                    </a-form-item>
                    <a-form-item>
                        <a-form-item>
                            <a-select mode="multiple" v-model="searchFrom.missiontype_id" placeholder="任务类型"
                                style="width: 180px;" allow-clear>
                                <a-select-option v-for="(item) in MissiontypeList" :key="item.id" :value="item.id">{{
                                    item.name }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>

                    </a-form-item>
                    <a-form-item>
                        <a-range-picker :show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm"
                            :placeholder="['任务开始时间', '任务结束时间']" @change="onChange" />
                    </a-form-item>

                    <a-form-item>
                        <a-button type="primary" htmlType="submit" icon="search" @click="tableSearch"></a-button>
                    </a-form-item>

                    <a-form-item>
                        <a-button type="primary" htmlType="submit" icon="download" @click="tabledownload"></a-button>
                    </a-form-item>
                    <br>
                    <a-divider></a-divider>
                    <a-form-item>
                        <span style="padding-right: 15px;"> 显示选择的章节:</span>
                        <a-switch v-model="isshowmission" />
                    </a-form-item>
                    <a-form-item>
                        <span style="padding-right: 15px;"> 只看正常参测</span>
                        <a-switch v-model="isshowcc" />
                    </a-form-item>
                    <a-form-item>
                        <span style="padding-right: 15px;"> 显示题目情况</span>
                        <a-switch v-model="isshowtm" />
                    </a-form-item>
                </a-form>

                <a-divider></a-divider>
                <div>
                    <a-tabs default-active-key="1">
                        <a-tab-pane key="1" tab="表格">

                            <a-table :dataSource="chapterlist" v-if="isshowmission" :rowKey="item => item.id"
                                :pagination="pageinfo" :loading="loading" @change="onPaginationChange" bordered>
                                <a-table-column key="gradename" title="年级">
                                    <template slot-scope="item">
                                        {{ item.name }}
                                    </template>
                                </a-table-column>

                                <!--  <a-table-column key="missionname" title="任务名">
                            <template slot-scope="item">
                               {{item.missionname}}
                            </template>
                        </a-table-column>
                        
                        <a-table-column key="missiontypename" title="任务类型">
                            <template slot-scope="item">
                               {{item.missiontypename}}
                            </template>
                        </a-table-column> -->

                            </a-table>
                            <a-divider></a-divider>

                            <a-table :dataSource="tabledata" :rowKey="item => item.id" :pagination="pageinfo"
                                :loading="loading" @change="onPaginationChange" bordered>
                                <a-table-column key="grade" title="年级">
                                    <template slot-scope="item">
                                        {{ item.grade_name }}
                                    </template>
                                </a-table-column>
                                <a-table-column key="subject" title="科目">
                                    <template slot-scope="item">
                                        {{ subjects[item.subject] }}
                                    </template>
                                </a-table-column>
                                <a-table-column key="grade" title="校区">
                                    <template slot-scope="item">
                                        {{ item.campusname }}
                                    </template>
                                </a-table-column>
                                <a-table-column key="name" title="班级">
                                    <template slot-scope="item">
                                        {{ item.grade_name }}{{ item.campusname }}{{ item.name }}
                                    </template>
                                </a-table-column>
                                <a-table-column key="squadtype" title="班型">
                                    <template slot-scope="item">
                                        {{ squadtype[item.type] }}
                                    </template>
                                </a-table-column>

                                <a-table-column key="banzhuren" title="班主任">
                                    <template slot-scope="item">
                                        {{ item.banzhuren }}
                                    </template>
                                </a-table-column>

                                <a-table-column key="teacher" title="任课老师" data-index="teachername" />

                                <a-table-column key="squad_all_usermission" title="总应参" data-index="squad_all_usermission"
                                    :sorter="(item1, item2) => item1.squad_all_usermission - item2.squad_all_usermission"
                                    v-if="!isshowcc" />
                                <a-table-column key="squad_all_student_actual" title="总实参"
                                    data-index="squad_all_student_actual"
                                    :sorter="(item1, item2) => item1.squad_all_student_actual - item2.squad_all_student_actual"
                                    v-if="!isshowcc" />
                                <a-table-column key="squad_student_arrive" title="应参/人次" data-index="squad_student_arrive"
                                    :sorter="(item1, item2) => item1.squad_student_arrive - item2.squad_student_arrive"
                                    v-if="isshowcc" />
                                <a-table-column key="squad_student_actual" title="实参/人次" data-index="squad_student_actual"
                                    :sorter="(item1, item2) => item1.squad_student_actual - item2.squad_student_actual"
                                    v-if="isshowcc" />
                                <a-table-column key="problems_cnt" title="应做题目" data-index="problems_cnt"
                                    :sorter="(item1, item2) => item1.problems_cnt - item2.problems_cnt" v-if="isshowtm" />
                                <a-table-column key="problems_tj_cnt" title="已做题目" data-index="problems_tj_cnt"
                                    :sorter="(item1, item2) => item1.problems_tj_cnt - item2.problems_tj_cnt"
                                    v-if="isshowtm" />
                                <a-table-column key="problems_isright" title="正确数" data-index="problems_isright"
                                    :sorter="(item1, item2) => item1.problems_isright - item2.problems_isright"
                                    v-if="isshowtm" />
                                <a-table-column key="problems_correct" title="批改题目" data-index="problems_correct"
                                    :sorter="(item1, item2) => item1.problems_correct - item2.problems_correct"
                                    v-if="isshowtm" />


                                <!--  <a-table-column key="sjccl2" title="实参(除住校)">
                            <template slot-scope="item">
                                {{parseFloat(item.squad_student_actual/item.squad_student_arrive).toFixed(2)}}
                            </template>
                        </a-table-column> -->
                                <a-table-column key="zsjccl" title="参测率" v-if="!isshowcc">
                                    <template slot-scope="item">
                                        <a-progress
                                            :percent="parseFloat((item.squad_all_student_actual / item.squad_all_usermission) * 100).toFixed(2)"
                                            size="small" status="active"
                                            v-if="(item.squad_all_student_actual / item.squad_all_usermission) > 0" />

                                    </template>
                                </a-table-column>

                                <a-table-column key="sjccl" title="实参率" v-if="isshowcc">
                                    <template slot-scope="item">
                                        <a-progress
                                            :percent="parseFloat((item.squad_student_actual / item.squad_student_arrive) * 100).toFixed(2)"
                                            status="active" size="small"
                                            v-if="(item.squad_student_actual / item.squad_student_arrive) > 0" />
                                    </template>
                                </a-table-column>
                                <a-table-column key="zql" title="正确率">
                                    <template slot-scope="item">

                                        <a-progress
                                            :percent="parseFloat((item.problems_isright / item.problems_correct) * 100).toFixed(2)"
                                            status="active" :strokeColor="strokeColor" size="small"
                                            v-if="(item.problems_isright / item.problems_correct) > 0" />
                                    </template>
                                </a-table-column>

                                <a-table-column key="sjpgl" title="批改率">

                                    <template slot-scope="item">
                                        <a-progress
                                            :percent="parseFloat((item.problems_correct / item.problems_tj_cnt) * 100).toFixed(2)"
                                            status="active" size="small"
                                            v-if="(item.problems_correct / item.problems_tj_cnt) > 0" />
                                    </template>
                                </a-table-column>
                                <a-table-column key="xiangqin" title="详情">
                                    <template slot-scope="item">
                                        <squadmissionlistmodel v-bind:itemdata="item" v-bind:searchFrom="searchFrom">
                                        </squadmissionlistmodel>

                                        | <Squadinfo v-bind:itemdata="item"></Squadinfo>
                                    </template>


                                </a-table-column>


                                <!--  <a-table-column key="nocc" title="不参测" data-index="nocc" /> -->
                                <!-- <a-table-column key="statistic" title="正常参测" data-index="statistic" />
                   
                        <a-table-column key="banzhuren" title="班主任" data-index="banzhuren" />
                        <a-table-column key="teacher" title="任课老师" data-index="teacher" />
                        <a-table-column key="type" title="班型">
                            <template slot-scope="item">
                                <span v-if="item.type==0">培优班</span>
                                <span v-if="item.type==1">提高班</span>
                                <span v-if="item.type==2">英才班</span>
                                <span v-if="item.type==3">1对1VIP班</span>
                            </template>
                        </a-table-column>
                        <a-table-column key="status" width="100px;" title="状态">
                            <template slot-scope="item">
                                <span v-if="item.status==1">可用</span>
                                <span v-if="item.status==0">已禁用</span>
                            </template>
                        </a-table-column> 
                      -->
                            </a-table>
                        </a-tab-pane>

                        <a-tab-pane key="2" tab="图表" force-render>
                            <!--   {{searchFrom.grade_id}}
                    {{searchFrom.chapter_id}} -->
                            <!--    <v-chart :forceFit="true" :height="400" :data="piedata" :scale="scale">
                        <v-tooltip :showTitle="false" dataKey="item*percent" />
                        <v-axis />
                        <v-legend dataKey="item" />
                        <v-pie position="percent" color="item" :v-style="pieStyle" :label="labelConfig" />
                        <v-coord type="theta" />
                    </v-chart> -->

                            <!--  <a-divider></a-divider>
                    <v-chart :forceFit="true" :padding="padding" :height="heightx" :data="chartdata">
                        <v-coord type="rect" direction="LB" />
                        <v-tooltip />
                        <v-legend />
                        <v-axis dataKey="label" label="nickname" />
                        <v-axis dataKey="label" position="right" />
                        <v-stack-bar position="nickname*value" color="type" />
                    </v-chart> -->
                        </a-tab-pane>
                    </a-tabs>



                </div>

            </a-col>
        </a-row>
        <record title="按章节查询完成情况" />
    </or-layout>
</template>

<script>
import Squadinfo from '@/views/basic/orgquadinfomodel.vue';
import AFormItem from "ant-design-vue/es/form/FormItem";
import squadmissionlistmodel from '@/views/dataanalyse/squadmissionlistmodel.vue';


// const DataSet = require('@antv/data-set');

export default {
    components: {
        AFormItem,
        squadmissionlistmodel,
        Squadinfo
    },
    data() {
        return {
            tabledata: [],
            squadtype: ["培优", "提高", "英才", "1v1", "体验课","冲刺班"],
            subjects:['','数学','英语','语文','化学','物理'],
            pageinfo: {
                total: 1,
                current: 1,
                pageSize: 999
            },
            strokeColor: {
                '0%': '#108ee9',
                '100%': '#87d068',
            },
            isshowmission: false,
            isshowcc: false,
            isshowtm: false,
            padding: [10, 80, 50, 100],
            gradeky:1,
            loading: false,
            courseList: [],
            grade_id: 'a8d63f687cf09ff50c4d4b7cc090568c',
            subject: 1,
            semester_id: 0,
            replaceFields: {
                children: 'children',
                title: 'name',
                key: 'id'
            },
            searchFrom: {
                keyword: undefined,
                grade_id: undefined,
                campus_id: undefined,
                missiontype_id: undefined,
                teachaername: undefined,
                chapter_id: [],
                type: undefined,
                start_time: Number,
                end_time: Number,
                opening: 1,
                user_type: 0,
                instructor: undefined,
                semester_name: '寒假',
                year_name: '2025',
                subject: undefined,
                is_famission: undefined,
                is_export: 0,
                interval: undefined,
            },
            chapter_id: [],
            dataviser: [],
            label: {
                offset: 12
            },
            campusList: [],
            MissiontypeList: [],
            gradeList: [],
            campuscount: [],
            missionlist: [],
            semesterlist: [],
            chapterlist: [],
            basicChapterList: [],
        };
    },
    mounted() {
        this.getCampusList();
        //this.getGradeList();
        this.getMissiontypeList();
        this.getsemester();
        this.getBasicChapter();

    },
    computed: {
        //  sumScData:function() {
        //       let me = this 
        //     const sData = "2222";

        //     me.tabledata.forEach(row => {
        //           this.sData = sData+row['problems_cnt']+"22221";
        //     });

        //     return me.tabledata;
        // },


    },

    methods: {
        handleChangegrade(value) {
            this.grade_id = value
            this.getBasicChapter();
        },
        handleChangesubject(value) {
            this.subject = value
            this.getBasicChapter();
        },
        handleChangesemester(value) {
            this.semester_id = value
            this.getBasicChapter();
        },
        selectchapterItem(selectedKeys, e) {
            e;
            this.chapter_id = selectedKeys;

            this.getchapterindex({ chapter_id: selectedKeys });
            this.searchFrom.chapter_id = selectedKeys;

            // this.getChapterTestpaper();
            // this.getChapterMission();

        },
        getBasicChapter() {
            this.$axios.post("/api/BasicChapter/gettreechapterbygrade"
                , {
                    data: {
                        'grade_id': this.grade_id,
                        'semester_id': this.semester_id,
                        'subject': this.subject,
                    },
                    pageinfo: this.testpaperpageinfo,
                })
                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                    } else {
                        this.basicChapterList = res.data;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });

        },
        getsemester() {
            this.$axios
                .post("/api/BasicSemester/index")
                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                    } else {
                        this.semesterlist = res.data.data;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });

        },
        getGradeList() {
            this.$axios
                .post("/api/BasicGrade/index")
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.gradeList = res.data.data;
                        this.grade_id = ['a8d63f687cf09ff50c4d4b7cc090568c'];
                        this.gradeky=2;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },

        getMissiontypeList() {
            this.$axios
                .post("/api/BasicMissionType/index")
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.MissiontypeList = res.data.data;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        onChange(value, dateString) {
            dateString,
                this.searchFrom.start_time = Number(value[0] / 1000);
            this.searchFrom.end_time = Number(value[1] / 1000);
            //this.searchForm.end_time=Number(value[1]/1000);
            // console.log('Selected Time: ', value[1]);
            // console.log('Formatted Selected Time: ', dateString[0]);
        },


        getCampusList() {
            this.$axios
                .post("/api/admin/getmycampuslist")
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.campusList = res.data;
                       // this.tableSearch();
                        //  this.getCourseList();
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },

        onPaginationChange(item) {
            this.pageinfo.current = item.current;
            this.getTableList(this.searchFrom);
        },
        tableSearch() {
            this.pageinfo.current = 1;
            this.searchFrom.is_export = 0;
            this.getTableList(this.searchFrom);
        },

        tabledownload() {
            this.pageinfo.current = 1;
            this.searchFrom.is_export = 1;
            this.getTableList(this.searchFrom);
        },


        getTableList(data) {
            this.loading = true;
            let params = JSON.parse(JSON.stringify(data));
            if(params.type){
                params.type = params.type.join(',')
            }
            if(params.campus_id){
                params.campus_id = params.campus_id.join(',')
            }
            this.$axios
                .post("/api/AnalyseInfo/getyuxiinfo", {
                    data:params,
                    pageinfo: this.pageinfo
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {

                        if (params.is_export != 1) {
                            this.tabledata = res.data.data;
                            this.missionlist = res.data.missionlist;
                        }
                        else {
                            window.open(res.data);
                        }
                    }
                })
                .catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loading = false;
                })
        },
        getchapterindex(data) {
            this.loading = true;
            this.$axios
                .post("/api/BasicChapter/getchapterindex", {
                    data,
                    pageinfo: this.pageinfo
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {

                        this.chapterlist = res.data.data;

                    }
                })
                .catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loading = false;
                })
        },
    },


};
</script>
<style>
.active_btn {
    margin-left: 5px;
}
</style>
